import { DataView } from "primereact/dataview";
import { Divider } from "primereact/divider";
import MeaButton from "../../../../components/MeaButton";
import { PERMISSION_TRAINING_ATTANDANCES, PERMISSION_TRAINING_STUDENTS } from "../../../../permissions";
import { classNames } from "primereact/utils";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import MeaLoadingContent from "../../../../components/MeaLoadingContent";
import MeaStudentRegistrationAvatar from "../../../../components/MeaStudentRegistrationAvatar";
import MeaStudentAvatar from "../../../trainings/components/MeaStudentAvatar";
import UpdateAttendanceMessageModal from "../../../trainings/attendances/components/UpdateAttendanceMessageModal";

const TodayAbsenteesComponent = ({ todaySessions, objectQuery, callback, schoolId, trainingId }) => {

  const [absentees, setAbsentees] = useState();

  const [visible, setVisible] = useState(false);
  const updateModalRef = useRef();
  const [attendance, setAttendance] = useState(null);

  useEffect(() => {
    if (todaySessions) {
      const absenteesList = todaySessions.flatMap(session =>
        session.attendances?.filter(attendance => attendance.status === "ABSENT")
      );
      setAbsentees(absenteesList);
    }
  }, [todaySessions]);


  const todayAbsenteesTemplate = (attendance, index) => {
    return (
      <div className={classNames('col-12 ', { 'bg-red-50': attendance?.message !== "" })} key={attendance.id}>
        <div className={classNames('flex flex-column pt-2 pb-2 xl:flex-row xl:align-items-start gap-2', { 'border-top-1 surface-border': index !== 0 })}>

          <div className="flex flex-column sm:flex-row justify-content-between align-items-center xl:align-items-start flex-1 gap-2">
            <div className="flex flex-column align-items-center sm:align-items-start gap-1">
              <MeaStudentAvatar student={attendance.student} permission={PERMISSION_TRAINING_STUDENTS.GET} schoolId={schoolId} trainingId={trainingId} />
              <span className="text-l text-500">{attendance?.message}</span>
            </div>
            <div className="flex sm:flex-column align-items-center sm:align-items-end gap-3 sm:gap-2">
              <div className="flex gap-2">

                <MeaButton icon="pi pi-phone" severity="success" onClick={() => {
                  setAttendance(attendance);
                  setVisible(true);
                }} />
                <MeaButton icon="pi pi-file-edit"
                  onClick={() => {
                    setAttendance(attendance);
                    if (updateModalRef.current) {
                      updateModalRef.current.show(() => {
                        callback?.();
                      });
                    }
                  }}
                  permission={PERMISSION_TRAINING_ATTANDANCES.UPDATE}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  const listTemplate = (items) => {
    if (!items || items.length === 0) return (
      <span className="text-500">Pas d'absents aujourd'hui.</span>
    );

    let list = items.map((attendance, index) => {
      return todayAbsenteesTemplate(attendance, index);
    });
    return <div className="grid grid-nogutter">{list}</div>;
  };

  return (
    <>
      <MeaLoadingContent objectQuery={objectQuery}>
        <DataView value={absentees} listTemplate={listTemplate} emptyMessage="Pas d'absents." />
      </MeaLoadingContent>
      <UpdateAttendanceMessageModal ref={updateModalRef} attendance={attendance} />
      <Dialog header="Personnes à contacter" visible={visible} onHide={() => setVisible(false)} >
        <div className="flex flex-column">
          <div className="text-500 w-full md:w-5 font-medium">Elève</div>
          <MeaStudentAvatar student={attendance?.student} permission={PERMISSION_TRAINING_STUDENTS.GET} schoolId={schoolId} trainingId={trainingId}   />
          <Divider />
          <ul className="list-none p-0 m-0">
            <li key="4" className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-5 font-medium">Père</div>
              <div className="text-900 w-full pl-3 md:w-7">
                <div className="flex justify-content-between flex-wrap align-items-center">
                  <div className="w-full">{(attendance?.student?.father_lastname || "") + " " + (attendance?.student?.father_firstname || "")}</div>
                  <div className="w-full">{attendance?.student?.father_phone && <Button icon="pi pi-phone" label={attendance?.student?.father_phone || "-"} severity="secondary" rounded onClick={() => {
                    window.open("tel:" + attendance?.student?.father_phone)
                  }} />} </div>

                </div>
              </div>
            </li>
            <li key="5" className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-5 font-medium">Mère</div>
              <div className="text-900 w-full pl-3 md:w-7">
                <div className="flex justify-content-between flex-wrap align-items-center">
                  <div className="w-full">{(attendance?.student?.mother_lastname || "") + " " + (attendance?.student?.mother_firstname || "")}</div>
                  <div className="w-full">{attendance?.student?.mother_phone && <Button icon="pi pi-phone" label={attendance?.student?.mother_phone || "-"} severity="secondary" rounded onClick={() => {
                    window.open("tel:" + attendance?.student?.mother_phone)
                  }} />} </div>

                </div>
              </div>
            </li>
            <li key="5" className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-5 font-medium">Personne 1</div>
              <div className="text-900 w-full pl-3 md:w-7">
                <div className="flex justify-content-between flex-wrap align-items-center">
                  <div className="w-full">{(attendance?.student?.contact_person_1 || "")}</div>
                  <div className="w-full">{attendance?.student?.contact_person_1_phone && <Button icon="pi pi-phone" label={attendance?.student?.contact_person_1_phone || "-"} severity="secondary" rounded onClick={() => {
                    window.open("tel:" + attendance?.student?.contact_person_1_phone)
                  }} />} </div>
                </div>
              </div>
            </li>
            <li key="5" className="flex align-items-start py-2 px-2 flex-wrap">
              <div className="text-500 w-full md:w-5 font-medium">Personne 2</div>
              <div className="text-900 w-full pl-3 md:w-7">
                <div className="flex justify-content-between flex-wrap align-items-center">
                  <div className="w-full">{(attendance?.student?.contact_person_2 || "")}</div>
                  <div className="w-full">{attendance?.student?.contact_person_2_phone && <Button icon="pi pi-phone" label={attendance?.student?.contact_person_2_phone || "-"} severity="secondary" rounded onClick={() => {
                    window.open("tel:" + attendance?.student?.contact_person_2_phone)
                  }} />} </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </Dialog>
    </>
  );
}

export default TodayAbsenteesComponent;